module.exports = __webpack_public_path__ + "static/media/DashboardSuccessAsset.c691176d.png";